import { Dialog } from '@mui/material';

import { redirectToLogin } from 'utils/auth';
import { GUEST_CTA } from 'utils/guestCta';

import GuestCtaButton from './GuestCtaButton';
import { closeLoginPrompt, useLoginPrompt } from './loginPromptStore';

/**
 * Advisory modal shown when a guest attempts a play action. Instead of yanking
 * the user straight to the login page, it explains they need an account and
 * lets them choose to authenticate or keep browsing as a guest.
 *
 * Mount once at the app root; trigger from anywhere via `promptLogin()`.
 */
const LoginRequiredModal = () => {
  const { open, title, message, dismissLabel } = useLoginPrompt();

  return (
    <Dialog
      open={open}
      onClose={closeLoginPrompt}
      PaperProps={{
        style: {
          background: '#1a1a1a',
          color: '#fff',
          borderRadius: 16,
          border: '1px solid rgba(247, 201, 72, 0.35)',
          padding: '28px 26px',
          maxWidth: 380,
          textAlign: 'center',
          boxShadow: '0 12px 48px rgba(0, 0, 0, 0.55)'
        }
      }}>
      <div style={{ fontSize: '1.25rem', fontWeight: 800, color: '#f7c948', marginBottom: 10 }}>
        {title}
      </div>
      <div style={{ fontSize: '0.95rem', lineHeight: 1.5, color: 'rgba(255,255,255,0.85)' }}>
        {message}
      </div>
      <div
        style={{
          display: 'flex',
          gap: 12,
          marginTop: 24,
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
        <button
          type='button'
          onClick={closeLoginPrompt}
          style={{
            cursor: 'pointer',
            border: '1px solid rgba(255, 255, 255, 0.25)',
            background: 'transparent',
            color: 'rgba(255,255,255,0.85)',
            padding: '11px 22px',
            borderRadius: 999,
            fontSize: '0.9rem',
            fontWeight: 600
          }}>
          {dismissLabel}
        </button>
        <GuestCtaButton
          label={GUEST_CTA.header}
          onClick={() => {
            closeLoginPrompt();
            redirectToLogin();
          }}
        />
      </div>
    </Dialog>
  );
};

export default LoginRequiredModal;
